import React from "react";

import Sidebar from "src/components/Layout/Sidebar";
import Header from "src/components/Layout/Header";
import Breadcrumb from "src/components/Layout/Breadcrumb";

const Layout = ({ children }) => {
  return (
    <div className="page fadeIn animated">
      <Sidebar />
      <div className="main-content" style={{ minHeight: 600 }}>
        <Header />
        <div className="container-fluid">
          <Breadcrumb />
          {children}
        </div>
      </div>
      <div className="main-footer">
        <div className="container-fluid pd-t-0-f ht-100p">
          <span>
            © {new Date().getFullYear()} <i>ХМТА цех </i>
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Layout);
